import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UISpinner = _resolveComponent("UISpinner")!
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createBlock(_component_UIButton, {
    disabled: _ctx.disabled,
    size: "small",
    use: "primary",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: _normalizeClass(["ml-4", {
      'cursor-not-allowed': _ctx.disabled,
      'bg-curious-blue-500 text-white hover:bg-curious-blue-400': !_ctx.disabled,
    }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.label)), 1),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_UISpinner, {
            key: 0,
            class: "absolute"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["disabled", "class"]))
}